export const MUELLES = ['32A', '32B', '32C', '32D', '32E', '32F', '32G', '34B', '90A', '90B'] as const
export type Muelle = (typeof MUELLES)[number]

export const ScaleEventType = {
  PLACE: 'PLACE',
  MARPOL: 'MARPOL',
  BOMBEO: 'BOMBEO',
} as const
export type ScaleEventType = (typeof ScaleEventType)[keyof typeof ScaleEventType]

export const SPECIAL_EVENT_TYPES = [ScaleEventType.MARPOL, ScaleEventType.BOMBEO] as const
export type SpecialEventType = (typeof SPECIAL_EVENT_TYPES)[number]

interface ScaleEventBase {
  id: string
  scaleId: string
  startTime: string
  endTime: string | null
}

export interface PlaceEvent extends ScaleEventBase {
  type: typeof ScaleEventType.PLACE
  muelle: Muelle
}

export interface SpecialEvent extends ScaleEventBase {
  type: SpecialEventType
}

export type ScaleEvent = PlaceEvent | SpecialEvent

export interface Scale {
  id: string
  isManual?: boolean
  seenInSource?: boolean
}

export const PRODUCT_CLASSES = ['HYDROCARBON', 'CHEMICAL'] as const
export type ProductClass = (typeof PRODUCT_CLASSES)[number]

export const OPERATION_KINDS = ['LOAD', 'UNLOAD'] as const
export type OperationKind = (typeof OPERATION_KINDS)[number]

type QuantityBasis = 'TONNES' | 'KG' | 'IMPLAUSIBLE'

export interface StayOperation {
  state: string | null
  operation: string | null
  kind: OperationKind | null
  goods: string | null
  productClass: ProductClass | null
  quantity: number | null
  unit: string | null
  quantityT: number | null
  quantityBasis: QuantityBasis | null
  estibador: string | null
  terminal: string | null
  windowStart: string | null
  windowEnd: string | null
}

export interface BombeoDetails {
  connectionPoint: string | null
  productClass: ProductClass | null
  product: string | null
  quantityT: number | null
  operationKind: OperationKind | null
}
